export function clearAllAddressFields({
    fullWidthFields,
    setState,
    setZip,
}: {
    fullWidthFields: any[]
    setState: Function
    setZip: Function
}) {
    for (let field of fullWidthFields) {
        field.setField('')
    }
    setState('')
    setZip('')
}
